// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1msst","col":"Table_col__1WZOF","fulfillmentStatus":"Table_fulfillmentStatus__141Uc","emailCol":"Table_emailCol__E3Rji"};